import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

// Константы для ID кнопок
export const BUTTON_IDS = {
  // Кнопки SurfaceButtonOpenSN
  TELEGRAM: "telegram",
  LINKEDIN: "linkedin",
  EMAIL: "email",
  BOSTONGENE: "bostongene",
  SBERTECH: "sbertech",

  // Можно добавить другие кнопки в будущем
  // SURFACE_BUTTON_OPEN: "surfaceButtonOpen",
  // SURFACE_BUTTON_START: "surfaceButtonStart",
};

export const useGame = create(
  subscribeWithSelector((set) => ({
    stop: 0,
    forward: 0,
    backward: 0,
    left: 0,
    right: 0,
    preparerace: false,
    startRace: false,
    moveCar: false,
    startTime: 0,
    endTime: 0,

    // Топ-3 лучших результата
    bestTimes: [],

    // Состояние фейерверков
    showFireworks: false,

    // Состояние кнопок SN (объект с уникальными ID)
    buttonStates: {},

    // Состояние кнопки Start Race
    isStartButtonActive: false,

    // Состояние кнопки Finish Race
    isFinishButtonActive: false,

    // Ссылка на контроллер машинки
    carController: null,

    // Состояние сброса машинки
    resetCar: false,
    triggerReset: () =>
      set(() => ({
        resetCar: true,
      })),
    clearReset: () =>
      set(() => ({
        resetCar: false,
      })),

    setDirection: (direction) =>
      set((state) => {
        // Если direction равен null, просто сбрасываем направления (без резкого stop)
        // Это позволит плавному затуханию работать
        if (direction === null) {
          const newState = {
            stop: 0, // Не устанавливаем stop: 1, чтобы не было резкого торможения
            forward: 0,
            backward: 0,
            left: 0,
            right: 0,
          };
          // Проверяем, изменилось ли состояние
          if (
            state.stop === newState.stop &&
            state.forward === newState.forward &&
            state.backward === newState.backward &&
            state.left === newState.left &&
            state.right === newState.right
          ) {
            return state; // Возвращаем старое состояние, если ничего не изменилось
          }
          return newState;
        }

        // Обрабатываем новые направления от rc-joystick
        const newState = {
          stop: 0,
          // Вперед: Top, TopLeft, TopRight, RightTop
          forward: Number(
            direction === "Top" ||
              direction === "TopLeft" ||
              direction === "TopRight" ||
              direction === "RightTop"
          ),
          // Назад: Bottom, BottomLeft, BottomRight, LeftBottom
          backward: Number(
            direction === "Bottom" ||
              direction === "BottomLeft" ||
              direction === "BottomRight" ||
              direction === "LeftBottom"
          ),
          // Влево: Left, TopLeft, BottomLeft, LeftBottom
          left: Number(
            direction === "Left" ||
              direction === "TopLeft" ||
              direction === "BottomLeft" ||
              direction === "LeftBottom"
          ),
          // Вправо: Right, TopRight, BottomRight, RightTop
          right: Number(
            direction === "Right" ||
              direction === "TopRight" ||
              direction === "BottomRight" ||
              direction === "RightTop"
          ),
        };

        // Проверяем, изменилось ли состояние
        if (
          state.stop === newState.stop &&
          state.forward === newState.forward &&
          state.backward === newState.backward &&
          state.left === newState.left &&
          state.right === newState.right
        ) {
          return state; // Возвращаем старое состояние, если ничего не изменилось
        }

        return newState;
      }),
    setRacePrepare: (preparerace) =>
      set(() => {
        return {
          preparerace: preparerace,
        };
      }),
    start: () =>
      set(() => {
        return {
          startRace: true,
          startTime: Date.now(),
          moveCar: true,
        };
      }),
    carMovedToStartLocation: () =>
      set(() => {
        return {
          moveCar: false,
        };
      }),
    end: () =>
      set((state) => {
        const currentTime = ((Date.now() - state.startTime) / 1000).toFixed(2);
        const newBestTimes = [...state.bestTimes, parseFloat(currentTime)]
          .sort((a, b) => a - b)
          .slice(0, 3); // Берем только топ-3

        return {
          startRace: false,
          endTime: Date.now(),
          bestTimes: newBestTimes,
          showFireworks: true,
        };
      }),

    // Функция для остановки фейерверков
    stopFireworks: () =>
      set(() => ({
        showFireworks: false,
      })),

    // Функции для управления кнопками SN
    // Используйте BUTTON_IDS.TELEGRAM, BUTTON_IDS.LINKEDIN, BUTTON_IDS.EMAIL
    setButtonOpenSN: (buttonId, isActive) =>
      set((state) => ({
        buttonStates: {
          ...state.buttonStates,
          [buttonId]: isActive,
        },
      })),

    // Функция для получения состояния конкретной кнопки
    isButtonOpenSN: (buttonId) => {
      const state = useGame.getState();
      return state.buttonStates[buttonId] || false;
    },

    // Функции для управления кнопкой Start Race
    setStartButtonActive: (isActive) =>
      set(() => ({
        isStartButtonActive: isActive,
      })),

    // Функции для управления кнопкой Finish Race
    setFinishButtonActive: (isActive) =>
      set(() => ({
        isFinishButtonActive: isActive,
      })),

    // Функция для установки контроллера машинки
    setCarController: (controller) =>
      set(() => ({
        carController: controller,
      })),
  }))
);
